import React, { useState } from 'react'
import { Button, Typography } from '@mui/material';
import { Modal } from 'react-bootstrap'
import UpdateForm from './UpdateForm'

export default function Cars() {

  const [lgShow, setLgShow] = useState(false);


  return (
    <>

      <div className="row my-3 ">
        <div className="col-md-6">
          <Typography className="mx-3" variant='h4' sx={{ pb: 3 }}>
            Cars
          </Typography>
        </div>
        <div className="col-md-6 d-flex justify-content-end"   >

          <button type="button" className="btn btn-danger" onClick={() => setLgShow(true)} style={{ height: "40px" }}  >Help</button>
          <Modal
            size="lg"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"

          >
            <Modal.Header closeButton style={{ color: '#FFFFFF', backgroundColor: '#C62828' }}>
              <Modal.Title id="example-modal-sizes-title-lg" >
                Instructions to Add/Edit Cars
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ol>
                <li>Select Account Name
                </li>
                <li>Select Country
                </li>
                <li>Click on Fetch Button
                </li>
                <li>Click On Add New Button
                </li>
                <li>Select the Car Class from the dropdown and from uplpoad image feild choose the car image which you want to upload
                </li>
                <li>Note : Upload Image should be JPG or JPEG format
                </li>
                <li>Click on the save Button
                </li>
              </ol>

              <h5>Existing Cars:
              </h5>
              <ul>
                <li>To view/edit/Download the existing Car Classes select the Account Name and Country name from the dropdown.
                </li>
              </ul>


            </Modal.Body>
          </Modal>

        </div>
      </div>


      {/* <div className="col-4 d-flex justify-content-end px-5">
        
          
         
        </div> */}




      <UpdateForm />





    </>
  );
}
